import React from 'react';
import { combineClasses } from '../utils/combineClasses';
import styles from './BackLink.module.css';

interface BackLinkProps {
  /** Destino de retorno: renderiza "Volver a {to}" (ej. "mis postulaciones"). */
  to?: string;
  /** Texto completo alternativo, si no se usa `to` (ej. history-back → "Volver"). */
  label?: string;
  /** Acción de navegación (navigate(ruta) o navigate(-1)). */
  onClick: () => void;
  className?: string;
}

// Control "Volver" homologado para los 3 roles: botón outline (afordancia clara
// para adultos mayores, sin competir con el CTA primario), flecha + destino
// específico. Ver docs/desviaciones-ui.md (molde propuesto, revisión de Pauli).
const BackLink: React.FC<BackLinkProps> = ({
  to,
  label,
  onClick,
  className,
}) => {
  const text = label ?? (to ? `Volver a ${to}` : 'Volver');
  return (
    <button
      type="button"
      className={combineClasses(styles.backLink, className)}
      onClick={onClick}
    >
      <i className="uc-icon icon-size--sm" aria-hidden="true">
        arrow_back
      </i>
      <span className={styles.label}>{text}</span>
    </button>
  );
};

export default BackLink;
